<template>
	<transition name="fade">
		<div v-if="current.status == 'win' || current.status == 'lose'" class="end-game">
			
			<div class="end-game-title">
				<span v-if="current.status == 'win'">{{ l.win_title }}</span>
				<span v-if="current.status == 'lose'">{{ l.lose_title }}</span>
			</div>
			<div class="end-game-subtitle">
				<span>{{ subtitle }}</span>
			</div>
			<div class="end-game-score">
				<span>Score : {{ score }}</span>
			</div>
			<div class="end-game-reward">
				<span v-if="current.status == 'win'">{{ l.win_reward }} {{ coins_earned }}<span class="icon"></span> !</span>
				<span v-if="current.status == 'lose'">{{ l.lose_reward }} +{{ coins_earned }}<span class="icon"></span></span>
			</div>
			
			<div class="end-game-buttons">
				<div class="button" @click="new_run()">{{ l.button_new_run }}</div>
				<div class="button back" @click="back()">{{ l.button_back }}</div>
			</div>

		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import Bus from '@/libs/bus'

export default {
	name: 'game',
	data: function() {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'l', 'lang', 'game', 'current' ]), {
		subtitle: function() {
			return this.l['win_subtitle'].replace('$n', this.game.stats.cards.monster)
		},
		score: function() {
			var multiplier = 1
			if (this.current.status == 'win') multiplier = 1.5
			var nb_cards = _.sum(_.values(this.game.stats.cards))
			return Math.round( (nb_cards + (this.game.stats.cards.gold / 2)) * multiplier )
		},
		coins_earned: function() {
			if (this.current.status == 'lose') return Math.round(this.game.player.hero.gold / 2)
			return this.game.player.hero.gold
		}
	}),
	methods: {
		new_run: function() {
			Bus.$emit('new-game', { hero_slug: this.game.player.hero.slug })
		},
		back: function() {
			this.$store.dispatch('set_screen', { screen: 'home' })
			this.$store.dispatch('clean_game')
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.end-game
	position absolute
	left 0
	top 50%
	right 0
	transform translateY(-50%)
	height ((card_height + 8) * 3)
	// background red
	text-align center
	padding 24px 16px
	transition 0.25s easeOutQuart
	&.fade-enter-active
		transition-delay 1s
	&.fade-enter
		opacity 0
	&.fade-leave-to
		opacity 0
	.end-game-title
		margin 0 0 16px 0
		font-size 6.4rem
		line-height 48px
	.end-game-subtitle
		margin 0 0 64px 0
		font-size 2.4rem
		line-height 24px
	.end-game-score
		margin 0 0 8px 0
		font-size 2.4rem
		line-height 24px
	.end-game-reward
		margin 0 0 32px 0
		font-size 2.4rem
		line-height 24px
		.icon
			display inline-block
			width 16px
			height 16px
			margin 0 0 0 4px
			background url(../../assets/img/ui/icons.png) 0 0 no-repeat
			background-position (-16px * 3) 0
			background-size auto 32px
	.end-game-buttons
		display block
		.button
			display inline-block
			height 64px
			padding 0 24px
			margin 0 8px
			font-size 2.4rem
			background light
			color dark
			line-height (@height - 2px)
			cursor pointer 2
			&.back
				background-color dark
				color light
				box-shadow inset 0 0 0 2px light
				&:hover
					background-color darken(dark, 15%)
				&:active
					background-color darken(dark, 25%)
			&:hover
				background-color lighten(light, 15%)
			&:active
				background-color lighten(light, 25%)
				transform translateY(1px)

</style>
